import { z } from 'zod'
import { env } from 'configs/EnvironmentConfig'
import fetch from 'auth/FetchInterceptor'
import { PaginationSchema, Validate } from './SchemaValidation'

const BillingService = {}

const uuid = z.string().uuid()

BillingService.getWallet = () =>
  fetch({
    url: `${env.BILLING_ENDPOINT_URL}/api/wallet/me`,
    method: 'GET',
  })

const cardRegisterSchema = z.object({
  encrypted: z.string(),
})

BillingService.postCard = function (data) {
  return fetch({
    url: `${env.BILLING_ENDPOINT_URL}/api/card`,
    method: 'POST',
    data: Validate(cardRegisterSchema, data),
  })
}

BillingService.deleteCard = cardId => {
  return fetch({
    url: `${env.BILLING_ENDPOINT_URL}/api/card/${Validate(uuid, cardId)}`,
    method: 'DELETE',
  })
}

BillingService.selectCard = cardId => {
  return fetch({
    url: `${env.BILLING_ENDPOINT_URL}/api/card/${Validate(
      uuid,
      cardId
    )}/select`,
    method: 'PUT',
  })
}

BillingService.listCards = function (params) {
  return fetch({
    url: `${env.BILLING_ENDPOINT_URL}/api/card`,
    method: 'GET',
    params: Validate(PaginationSchema, params),
  })
}

BillingService.getCard = function (cardId) {
  return fetch({
    url: `${env.BILLING_ENDPOINT_URL}/api/card/${cardId}`,
    method: 'GET',
  })
}

const postOrderSchema = z.object({
  funds: z.number(),
  coupon: z.string().optional(),
  payment_type_id: z.number().refine(value => [1, 2, 3].includes(value)),
  credit_card: z
    .object({
      card_id: z.string().uuid(),
      encrypted: z.string(),
    })
    .partial()
    .optional(),
})

BillingService.postOrder = data => {
  return fetch({
    url: `${env.BILLING_ENDPOINT_URL}/api/order`,
    method: 'POST',
    data: Validate(postOrderSchema, data),
  })
}

BillingService.listOrders = params =>
  fetch({
    url: `${env.BILLING_ENDPOINT_URL}/api/order`,
    method: 'GET',
    params: Validate(PaginationSchema, params),
  })

BillingService.listWalletLogs = params =>
  fetch({
    url: `${env.BILLING_ENDPOINT_URL}/api/wallet/me/log`,
    method: 'GET',
    params: Validate(PaginationSchema, params),
  })

BillingService.getOrder = orderId =>
  fetch({
    url: `${env.BILLING_ENDPOINT_URL}/api/order/${Validate(uuid, orderId)}`,
    method: 'GET',
  })

BillingService.cancelOrder = id =>
  fetch({
    url: `${env.BILLING_ENDPOINT_URL}/api/order/${Validate(uuid, id)}`,
    method: 'PUT',
    data: {
      cancel: true,
    },
  })

const editOrderSchema = z
  .object({
    payment_type_id: z.number().refine(value => [1, 2, 3, 4].includes(value)),
    credit_card: z
      .object({
        card_id: z.string().uuid(),
        encrypted: z.string(),
      })
      .partial()
      .optional(),
  })
  .optional()

BillingService.editOrder = rawData => {
  const { id, ...data } = rawData

  return fetch({
    url: `${env.BILLING_ENDPOINT_URL}/api/order/${Validate(uuid, id)}`,
    method: 'PUT',
    data: Validate(editOrderSchema, data),
  })
}

BillingService.payOrder = orderId =>
  fetch({
    url: `${env.BILLING_ENDPOINT_URL}/api/order/${Validate(
      uuid,
      orderId
    )}/checkout`,
    method: 'POST',
  })

BillingService.getRewards = () =>
  fetch({
    url: `${env.BILLING_ENDPOINT_URL}/api/reward`,
    method: 'GET',
  })

BillingService.refreshRewards = () =>
  fetch({
    url: `${env.BILLING_ENDPOINT_URL}/api/reward/refresh`,
    method: 'PATCH',
  })

export default BillingService
